import { render, staticRenderFns } from "./UGSGameVersionConfig.vue?vue&type=template&id=263c8f90&scoped=true&"
import script from "./UGSGameVersionConfig.vue?vue&type=script&lang=js&"
export * from "./UGSGameVersionConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263c8f90",
  null
  
)

export default component.exports